"use client";

// src/primitives/MarkdownText.tsx
import { INTERNAL, useContentPartText } from "@assistant-ui/react";
import {
  forwardRef,
  useMemo
} from "react";
import ReactMarkdown from "react-markdown";
import { PreOverride } from "../overrides/PreOverride.js";
import {
  DefaultPre,
  DefaultCode,
  DefaultCodeBlockContent,
  DefaultCodeHeader
} from "../overrides/defaultComponents.js";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { CodeOverride } from "../overrides/CodeOverride.js";
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
var { useSmooth, useSmoothStatus, withSmoothContextProvider } = INTERNAL;
var MarkdownTextInner = ({
  components: userComponents,
  componentsByLanguage,
  smooth = true,
  ...rest
}) => {
  const { text } = useSmooth(useContentPartText(), smooth);
  const {
    pre = DefaultPre,
    code = DefaultCode,
    SyntaxHighlighter = DefaultCodeBlockContent,
    CodeHeader = DefaultCodeHeader
  } = userComponents ?? {};
  const useCodeOverrideComponents = useMemo(() => {
    return {
      Pre: pre,
      Code: code,
      SyntaxHighlighter,
      CodeHeader
    };
  }, [pre, code, SyntaxHighlighter, CodeHeader]);
  const CodeComponent = useCallbackRef((props) => /* @__PURE__ */ jsx(
    CodeOverride,
    {
      components: useCodeOverrideComponents,
      componentsByLanguage,
      ...props
    }
  ));
  const components = useMemo(() => {
    const {
      pre: pre2 = DefaultPre,
      code: code2 = DefaultCode,
      SyntaxHighlighter: SyntaxHighlighter2 = DefaultCodeBlockContent,
      CodeHeader: CodeHeader2 = DefaultCodeHeader,
      ...componentsRest
    } = userComponents ?? {};
    return {
      ...componentsRest,
      pre: PreOverride,
      code: CodeComponent
    };
  }, [CodeComponent, userComponents]);
  return /* @__PURE__ */ jsx(ReactMarkdown, { components, ...rest, children: text });
};
var MarkdownTextPrimitiveImpl = forwardRef(
  ({
    className,
    containerProps,
    containerComponent: Container = "div",
    ...rest
  }, forwardedRef) => {
    const status = useSmoothStatus();
    return /* @__PURE__ */ jsx(
      Container,
      {
        "data-status": status.type,
        ...containerProps,
        className: classNames(className, containerProps?.className),
        ref: forwardedRef,
        children: /* @__PURE__ */ jsx(MarkdownTextInner, { ...rest })
      }
    );
  }
);
MarkdownTextPrimitiveImpl.displayName = "MarkdownTextPrimitive";
var MarkdownTextPrimitive = withSmoothContextProvider(
  MarkdownTextPrimitiveImpl
);
export {
  MarkdownTextPrimitive
};
//# sourceMappingURL=MarkdownText.js.map